import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnInit,
} from '@angular/core';
import { setCssProperty } from '../../../cross-team-shared/misc-utils';

@Component({
  selector: 'h3-column',
  template: '<ng-content></ng-content>',
  styleUrls: ['./column.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ColumnComponent implements OnInit {
  @Input() width?: string;

  constructor(private elementRef: ElementRef<HTMLElement>) {}

  ngOnInit() {
    setCssProperty(this.elementRef, 'width', this.width);
    setCssProperty(this.elementRef, 'flex-grow', this.width ? null : 1);
  }
}
